// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!

/* tslint:disable */
export const VERSION = {
  version: "7.9.1",
  date: "2026-09-17T06:57:02.022Z",
  gitInfo: {
    dirty: false,
    raw: "f72e975f6",
    hash: "f72e975f6",
    distance: null,
    tag: null,
    semver: null,
    suffix: "f72e975f6",
    semverString: null
  }
};
/* tslint:enable */
